import { FC, useEffect } from 'react';
import closeIcon from 'assets/icons/Close.svg';
import Portal from '../Modal/Portal';
import SvgIcon from 'shared/components/SvgIcon/SvgIcon';
import SidebarStyles from './Sidebar.module.scss';
import Icons from 'styles/icons.module.scss';

interface ISidebar {
	close: () => void;
	render: any;
	title: string;
	icon?: string;
	children?: React.ReactNode;
}

const Sidebar: FC<ISidebar> = ({ children, close, render, title, icon }) => {
	useEffect(() => {
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	return (
		<Portal>
			<div className={SidebarStyles.sidebarRoot}>
				<div className={SidebarStyles.sidebarBackdrop} onClick={close} />
				<div className={SidebarStyles.sidebarWrapper}>
					<div className={SidebarStyles.sidebarHeader}>
						<div className={SidebarStyles.sidebarTitle}>
							{icon && <SvgIcon spriteUrl={icon} className={Icons.modalIcon} />}
							<h4>{title}</h4>
						</div>
						<SvgIcon spriteUrl={closeIcon} className={SidebarStyles.sidebarCloseIcon} onClick={close} />
					</div>
					<div className={SidebarStyles.sidebarContent}>
						{render(children) || children}
					</div>
				</div>
			</div>
		</Portal>
	);
};

export default Sidebar;

